import React, { PureComponent } from "react";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import Grid from "../Grid/Grid";
import GridTitle from "../GridTitle/GridTitle";
import CategoryBanner from "../CategoryBanner/CategoryBanner";
import "./ChannelsMenu.scss";
import "./Header.scss";
import api_calls from "../../utils/api_calls";

const menuChannels = [
    { title: 'Trends', id: 224327992 }, // latest
    { title: 'Tile', id: 224327993 },
    { title: 'Stone', id: 224327994 },
    { title: 'Wood', id: 224327995 },
    { title: 'Laminate', id: 224983960 },
    { title: 'Vinyl', id: 224327997 },
    { title: 'Decoratives', id: 224327998 },
    { title: 'How-To', id: 224327999 }
];

class Channels extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedChannelId: 0,
            tabActive: 1,
            channelApiUrl: "",
            userInteraction: false,
            selectedChannel: null,
        };
        this.debounceTimeout = null;
    }

    getApiUrl = (channelId, tabActive) => {
        let url = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}/channels/${channelId}/contents`;
        if (tabActive === 2) {
            url += "?od=DESC&o=views";
        }
        return url;
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let selectedChannelId = parseInt(urlParams.get("channelId"), 10) || 0;
        const tabActive = parseInt(urlParams.get("tab"), 10) || 1;
        const pathParts = window.location.pathname.split("/");
        const channelIndex = pathParts.findIndex((part) => part === "c");
    
        // If channel ID is found in URL path (e.g., /c/{channelId})
        if (channelIndex !== -1 && pathParts[channelIndex + 2]) {
            selectedChannelId = parseInt(pathParts[channelIndex + 2], 10);
        }
    
        // Check if the selected channel is from the predefined list
        const selectedChannel = menuChannels.find(
            (channel) => channel.id === selectedChannelId
        );
    
        // If it's a valid channel, proceed with normal flow
        if (selectedChannel) {
            this.onFlagChange(false);
        }
    
        // Always set the API URL even if the channel is not in `menuChannels`
        this.setState({
            selectedChannelId,
            tabActive,
            selectedChannel,
            channelApiUrl: this.getApiUrl(selectedChannelId, tabActive),
        });
        if(!selectedChannel && selectedChannelId){
            api_calls.channelInfo(`${ConfigurationHelper.getGlobalConfiguration().apiUrl}/channels/${selectedChannelId}`).then(({data})=>{
                this.setState({
                    selectedChannel: data,
                });
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedChannelId, tabActive, userInteraction } = this.state;

        if (
            userInteraction && 
            (prevState.tabActive !== tabActive || prevState.selectedChannelId !== selectedChannelId)
        ) {
            const channelApiUrl = this.getApiUrl(selectedChannelId, tabActive);
            this.setState({ channelApiUrl, userInteraction: false }, () => {
                this.updateQueryParams(selectedChannelId, tabActive);
            });
        }
    }

    updateQueryParams = (channelId, tabActive) => {
        const url = new URL(window.location);
        const searchParams = url.searchParams;

        // Update or add 'channelId' and 'tab' parameters
        searchParams.set('channelId', channelId);
        searchParams.set('tab', tabActive);

        // Update the URL without removing other existing parameters
        window.history.replaceState({}, '', `${url.pathname}?${searchParams.toString()}`);
    };

    handleTabChange = (tabActive) => {
        this.setState({ tabActive, userInteraction: true });
    };

    handleChannelChange = (channelId) => {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
            this.setState({ selectedChannelId: channelId, userInteraction: true }, () => {
                this.onFlagChange(false);
            });
        }, 500);
    };

    onFlagChange = (val) => {
        this.props.onFlagChange(val);
    };

    render() {
        const { selectedChannelId, tabActive, channelApiUrl, selectedChannel } = this.state;
        
        return (
            <>
                <div className={"container gc"}>
                    <div className="videopage-selections">
                        <div className="gs-top-row">
                            {menuChannels.map((element, id) => {
                                const isDisabled = selectedChannelId === element.id;
                                const className = isDisabled
                                    ? "tr-option select-active disabled"
                                    : "tr-option";

                                return (
                                    <div
                                        key={id + element.id}
                                        id={element.title.toLowerCase()}
                                        onClick={
                                            !isDisabled
                                                ? () => this.handleChannelChange(element.id)
                                                : null
                                        }
                                        role="button"
                                        aria-pressed="false"
                                        className={className}
                                        style={{ cursor: isDisabled ? 'default' : 'pointer' }} 
                                    >
                                        {element.title}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="videopage-selections-mobile">
                        <div className="gs-top-row-mobile">
                            <select
                                id="tr-select"
                                style={{ display: "inline-block" }}
                                onChange={(event) => this.handleChannelChange(Number(event.target.value))}
                                value={selectedChannelId}
                            >
                                {menuChannels.map((element, id) => (
                                    <option
                                        key={id + element.id}
                                        aria-pressed="false"
                                        className="tr-option"
                                        value={element.id}
                                    >
                                        {element.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {selectedChannelId ? (
                    <div className="app-container-video">
                        <div className="document-body">
                            <div className="container ">
                                <div className="row">
                                    <div className="col-7 col-sm-8 col-md-9">
                                        <ul className="tvp-breadcrumbs keep-on-mobile">
                                            <li itemScope itemType="http://data-vocabulary.org/Breadcrumb">
                                                <div>
                                                    <span 
                                                        itemProp="title" 
                                                        className="breadcrumb-button"
                                                        onClick={() => {
                                                            const url = new URL(window.location);
                                                            // Optionally remove specific query parameters
                                                            // url.searchParams.delete('channelId');
                                                            // url.searchParams.delete('tab');
                                                            window.history.replaceState({}, '', `${url.pathname}?${url.searchParams.toString()}`);
                                                            window.location.href = ConfigurationHelper.getGlobalConfiguration().sub_folder + "/";
                                                        }}
                                                    >
                                                        Home
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {selectedChannel ? (<CategoryBanner channel={selectedChannel} />) : null}
                            <div className={"container grid-tabs-container"} style={{marginTop:selectedChannel? 0 : "32px"}}>
                                <div className={"row"}>
                                    <div className={"col-md-6 tab-line"}>
                                        <GridTitle className={"more-from-this-category"}>
                                            <span>MORE FROM THIS CATEGORY</span>
                                        </GridTitle>
                                    </div>
                                    <div className={"col-md-6 tab-line"}>
                                        <div className={"grid-tabs"}>
                                            <div
                                                onClick={() => this.handleTabChange(1)}
                                                className={
                                                    "grid-tab " +
                                                    (tabActive === 1 ? "active" : "")
                                                }
                                            >
                                                <span>Most Recent</span>
                                            </div>
                                            <div
                                                onClick={() => this.handleTabChange(2)}
                                                className={
                                                    "grid-tab " +
                                                    (tabActive === 2 ? "active" : "")
                                                }
                                            >
                                                <span>Most Viewed</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"grid-container active"}>
                                <Grid
                                    key={channelApiUrl}
                                    gridTitle=""
                                    baseApiUrl={channelApiUrl}
                                    videos={[]}
                                    analyticsForFirstAsset={true}
                                    channel={{ id: selectedChannelId }}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
            </>
        );
    }
}

export default Channels;
